import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_0744701e from 'nuxt_plugin_plugin_0744701e' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_4f9be048 from 'nuxt_plugin_cookieuniversalnuxt_4f9be048' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_plugin_fa259800 from 'nuxt_plugin_plugin_fa259800' // Source: ./nuxt-perfect-cache/plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_043b1da6 from 'nuxt_plugin_vuesocialsharingplugin_043b1da6' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_gtm_09089c0a from 'nuxt_plugin_gtm_09089c0a' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginutils_379c0487 from 'nuxt_plugin_pluginutils_379c0487' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_76ad8c12 from 'nuxt_plugin_pluginrouting_76ad8c12' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_31eb289d from 'nuxt_plugin_pluginmain_31eb289d' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_pluginDelayHydrationclient_c20b5a62 from 'nuxt_plugin_pluginDelayHydrationclient_c20b5a62' // Source: ./hydration/pluginDelayHydration.client.mjs (mode: 'client')
import nuxt_plugin_workbox_607adf60 from 'nuxt_plugin_workbox_607adf60' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_fa22f13a from 'nuxt_plugin_metaplugin_fa22f13a' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_f0d3a652 from 'nuxt_plugin_iconplugin_f0d3a652' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_4a675834 from 'nuxt_plugin_axios_4a675834' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_router_925f8c0a from 'nuxt_plugin_router_925f8c0a' // Source: ./router.js (mode: 'all')
import nuxt_plugin_polyfill_14930cc5 from 'nuxt_plugin_polyfill_14930cc5' // Source: ../plugins/polyfill (mode: 'all')
import nuxt_plugin_axios_fb9c9a02 from 'nuxt_plugin_axios_fb9c9a02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_inject_5dc257b0 from 'nuxt_plugin_inject_5dc257b0' // Source: ../plugins/inject (mode: 'all')
import nuxt_plugin_apollo_784ac076 from 'nuxt_plugin_apollo_784ac076' // Source: ../plugins/apollo (mode: 'all')
import nuxt_plugin_global_6441a2ce from 'nuxt_plugin_global_6441a2ce' // Source: ../plugins/global (mode: 'all')
import nuxt_plugin_image_fac56038 from 'nuxt_plugin_image_fac56038' // Source: ../plugins/image (mode: 'all')
import nuxt_plugin_webpplugin_28979de9 from 'nuxt_plugin_webpplugin_28979de9' // Source: ../plugins/webp-plugin.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'all')
import nuxt_plugin_axiosport_27427124 from 'nuxt_plugin_axiosport_27427124' // Source: ../plugins/axios-port (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_nuxtclientinit_181bd504 from 'nuxt_plugin_nuxtclientinit_181bd504' // Source: ../plugins/nuxt-client-init (mode: 'all')
import nuxt_plugin_filter_688a13e2 from 'nuxt_plugin_filter_688a13e2' // Source: ../plugins/filter (mode: 'all')
import nuxt_plugin_vuelazyload_025de73c from 'nuxt_plugin_vuelazyload_025de73c' // Source: ../plugins/vue-lazy-load (mode: 'all')
import nuxt_plugin_jsonld_2ff766e1 from 'nuxt_plugin_jsonld_2ff766e1' // Source: ../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_vjs_6a86ca76 from 'nuxt_plugin_vjs_6a86ca76' // Source: ../plugins/v-js (mode: 'all')
import nuxt_plugin_clickoutside_5b0e370d from 'nuxt_plugin_clickoutside_5b0e370d' // Source: ../plugins/click-outside.js (mode: 'all')
import nuxt_plugin_sendErrorReport_2549928e from 'nuxt_plugin_sendErrorReport_2549928e' // Source: ../plugins/sendErrorReport.js (mode: 'all')
import nuxt_plugin_dragscroll_79e590b2 from 'nuxt_plugin_dragscroll_79e590b2' // Source: ../plugins/drag-scroll.js (mode: 'client')
import nuxt_plugin_vscrolllock_1c8c6f99 from 'nuxt_plugin_vscrolllock_1c8c6f99' // Source: ../plugins/v-scroll-lock.js (mode: 'client')
import nuxt_plugin_vuemodal_46b5cf07 from 'nuxt_plugin_vuemodal_46b5cf07' // Source: ../plugins/vue-modal.js (mode: 'client')
import nuxt_plugin_breakpoint_08bc58b0 from 'nuxt_plugin_breakpoint_08bc58b0' // Source: ../plugins/breakpoint.js (mode: 'client')
import nuxt_plugin_vueobservevisibility_66676af7 from 'nuxt_plugin_vueobservevisibility_66676af7' // Source: ../plugins/vue-observe-visibility.js (mode: 'client')
import nuxt_plugin_vuetouchevents_b675309a from 'nuxt_plugin_vuetouchevents_b675309a' // Source: ../plugins/vue-touch-events.js (mode: 'client')
import nuxt_plugin_vuepinchzoom_555b2318 from 'nuxt_plugin_vuepinchzoom_555b2318' // Source: ../plugins/vue-pinch-zoom.js (mode: 'client')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../plugins/vuex-persist (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Tubber","titleTemplate":"%s","meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"},{"name":"twitter:card","content":"summary"},{"name":"twitter:site","content":"@TubberBoats"},{"name":"twitter:creator","content":"@TubberBoats"},{"property":"fb:app_id","content":"781436315306170"},{"http-equiv":"Content-Security-Policy","content":"default-src * self blob: data: gap:; style-src * self 'unsafe-inline' blob: data: gap:; script-src * 'self' 'unsafe-eval' 'unsafe-inline' blob: data: gap:; object-src * 'self' blob: data: gap:; img-src * self 'unsafe-inline' blob: data: gap:; connect-src self * 'unsafe-inline' blob: data: gap:; frame-src * self blob: data: gap:;"},{"name":"site_name","property":"og:site_name","content":"Tubber"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"name":"robots","content":"index, follow"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto:wght@400;500;700;800;900&family=Open Sans:wght@400;500;600;700;800&display=swap"}],"__dangerouslyDisableSanitizers":["script","innerHTML"],"style":[],"script":[{"hid":"gtm-script","innerHTML":"var gtmTimer = setTimeout(function() {(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https:\u002F\u002Fsst.tubber.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-5X8Q8Q');}, 6000);var gtevents = ['mouseover', 'keydown', 'touchstart', 'scroll'];gtevents.forEach(function(event) {window.addEventListener(event, triggerGtm, { once: true });});function triggerGtm() {clearTimeout(gtmTimer);gtevents.forEach(function(event) {window.removeEventListener(event, triggerGtm);});(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https:\u002F\u002Fsst.tubber.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-5X8Q8Q')}function injectScript(url) {const script = document.createElement('script'); script.src = url; script.type = 'text\u002Fjavascript'; script.defer = true; document.head.appendChild(script);}setTimeout(function scripts() {injectScript(\"https:\u002F\u002Fwww.google.com\u002Frecaptcha\u002Fenterprise.js?render=6LergzosAAAAANRiH17D_j0qby18iQk2R5L2gjW7\");injectScript(\"https:\u002F\u002Fob.esnbranding.com\u002Fi\u002F64bc45bb2f649c2779902ed5e14e4b3d.js\");},6000);\n"},{"hid":"trustpilot","src":"https:\u002F\u002Fwidget.trustpilot.com\u002Fbootstrap\u002Fv5\u002Ftp.widget.bootstrap.min.js","async":true,"defer":true},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto:wght@400;500;700;800;900&family=Open Sans:wght@400;500;600;700;800&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fsst.tubber.com\u002Fns.html?id=GTM-5X8Q8Q\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"},{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Roboto:wght@400;500;700;800;900&family=Open Sans:wght@400;500;600;700;800&display=swap\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_0744701e === 'function') {
    await nuxt_plugin_plugin_0744701e(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_4f9be048 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_4f9be048(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_fa259800 === 'function') {
    await nuxt_plugin_plugin_fa259800(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_043b1da6 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_043b1da6(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_09089c0a === 'function') {
    await nuxt_plugin_gtm_09089c0a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_379c0487 === 'function') {
    await nuxt_plugin_pluginutils_379c0487(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_76ad8c12 === 'function') {
    await nuxt_plugin_pluginrouting_76ad8c12(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_31eb289d === 'function') {
    await nuxt_plugin_pluginmain_31eb289d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginDelayHydrationclient_c20b5a62 === 'function') {
    await nuxt_plugin_pluginDelayHydrationclient_c20b5a62(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_607adf60 === 'function') {
    await nuxt_plugin_workbox_607adf60(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_fa22f13a === 'function') {
    await nuxt_plugin_metaplugin_fa22f13a(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_f0d3a652 === 'function') {
    await nuxt_plugin_iconplugin_f0d3a652(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4a675834 === 'function') {
    await nuxt_plugin_axios_4a675834(app.context, inject)
  }

  if (typeof nuxt_plugin_router_925f8c0a === 'function') {
    await nuxt_plugin_router_925f8c0a(app.context, inject)
  }

  if (typeof nuxt_plugin_polyfill_14930cc5 === 'function') {
    await nuxt_plugin_polyfill_14930cc5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_fb9c9a02 === 'function') {
    await nuxt_plugin_axios_fb9c9a02(app.context, inject)
  }

  if (typeof nuxt_plugin_inject_5dc257b0 === 'function') {
    await nuxt_plugin_inject_5dc257b0(app.context, inject)
  }

  if (typeof nuxt_plugin_apollo_784ac076 === 'function') {
    await nuxt_plugin_apollo_784ac076(app.context, inject)
  }

  if (typeof nuxt_plugin_global_6441a2ce === 'function') {
    await nuxt_plugin_global_6441a2ce(app.context, inject)
  }

  if (typeof nuxt_plugin_image_fac56038 === 'function') {
    await nuxt_plugin_image_fac56038(app.context, inject)
  }

  if (typeof nuxt_plugin_webpplugin_28979de9 === 'function') {
    await nuxt_plugin_webpplugin_28979de9(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosport_27427124 === 'function') {
    await nuxt_plugin_axiosport_27427124(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtclientinit_181bd504 === 'function') {
    await nuxt_plugin_nuxtclientinit_181bd504(app.context, inject)
  }

  if (typeof nuxt_plugin_filter_688a13e2 === 'function') {
    await nuxt_plugin_filter_688a13e2(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyload_025de73c === 'function') {
    await nuxt_plugin_vuelazyload_025de73c(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_2ff766e1 === 'function') {
    await nuxt_plugin_jsonld_2ff766e1(app.context, inject)
  }

  if (typeof nuxt_plugin_vjs_6a86ca76 === 'function') {
    await nuxt_plugin_vjs_6a86ca76(app.context, inject)
  }

  if (typeof nuxt_plugin_clickoutside_5b0e370d === 'function') {
    await nuxt_plugin_clickoutside_5b0e370d(app.context, inject)
  }

  if (typeof nuxt_plugin_sendErrorReport_2549928e === 'function') {
    await nuxt_plugin_sendErrorReport_2549928e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dragscroll_79e590b2 === 'function') {
    await nuxt_plugin_dragscroll_79e590b2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vscrolllock_1c8c6f99 === 'function') {
    await nuxt_plugin_vscrolllock_1c8c6f99(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemodal_46b5cf07 === 'function') {
    await nuxt_plugin_vuemodal_46b5cf07(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_breakpoint_08bc58b0 === 'function') {
    await nuxt_plugin_breakpoint_08bc58b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibility_66676af7 === 'function') {
    await nuxt_plugin_vueobservevisibility_66676af7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetouchevents_b675309a === 'function') {
    await nuxt_plugin_vuetouchevents_b675309a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepinchzoom_555b2318 === 'function') {
    await nuxt_plugin_vuepinchzoom_555b2318(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.push(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
